import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=369f4c34&scoped=true&"
import script from "./ReservationList.vue?vue&type=script&lang=ts&"
export * from "./ReservationList.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=369f4c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f4c34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
